import React from "react";
import { Wrench } from "lucide-react";
import type { PrioritizedIssue } from "../hooks/useMCPContext";
import QuickFixButton from "./QuickFixButton";

interface QuickFixListProps {
  issues: PrioritizedIssue[];
  onIssueClick: (issue: PrioritizedIssue) => void;
  completedIssueIds?: string[];
}

const QuickFixList: React.FC<QuickFixListProps> = ({
  issues,
  onIssueClick,
  completedIssueIds = [],
}) => {
  const pending = issues.filter(
    (i) => i.status !== "fixed" && !completedIssueIds.includes(i.id)
  );

  if (pending.length === 0) {
    return (
      <div className="ml-[34px] mt-3 rounded-xl px-4 py-6 text-center text-sm text-og01-text-muted">
        🎉 All issues fixed! Great work improving your site.
      </div>
    );
  }

  return (
    <div className="ml-[34px] mt-3 rounded-xl border border-white/[0.07] bg-[#0F0F18] p-4">
      <div className="mb-1 flex items-center gap-2">
        <Wrench className="h-4 w-4" style={{ color: "var(--accent, #8B5CF6)" }} />
        <span className="text-sm font-semibold text-og01-text">Quick Fixes Available</span>
      </div>
      <p className="mb-3 text-xs text-og01-text-muted">Click each issue to generate a fix:</p>
      <div className="space-y-2 overflow-x-hidden overflow-y-auto" style={{ maxHeight: "400px" }}>
        {pending.map((issue) => (
          <QuickFixButton key={issue.id} issue={issue} onClick={() => onIssueClick(issue)} />
        ))}
      </div>
      {pending.length > 5 && (
        <p className="mt-2 text-center text-[10px] text-og01-text-muted">
          Scroll for {pending.length - 5} more
        </p>
      )}
    </div>
  );
};

export default QuickFixList;
